import React from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { Box } from '@mui/material';
import SortableSeriesItem from './SortableSeriesItem';

const SortableSeriesList = ({ items, onSortEnd, onSessionDataChange }) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const oldIndex = items.findIndex((item) => item.id === active.id);
      const newIndex = items.findIndex((item) => item.id === over.id);
      onSortEnd({ oldIndex, newIndex });
    }
  };

  return (
    <Box sx={{ bgcolor: 'background.paper', borderRadius: 1 }}>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={items.map(item => item.id)}
          strategy={verticalListSortingStrategy}
        >
          {items.map((item) => (
            <SortableSeriesItem
              key={item.id}
              id={item.id}
              label={item.label}
              seriesDay={item.seriesDay}
              isDarkMode={item.isDarkMode}
              onDataChange={onSessionDataChange}
            />
          ))}
        </SortableContext>
      </DndContext>
    </Box>
  );
};

export default SortableSeriesList; 